import {
  FormGridItem,
  type FormGridItemProps,
  TextField,
  type TextFieldProps,
  useMultilineTextValidator,
} from '@ace-clublabs/shared-component-library';

import { defaultInputProps, getRequiredFieldSx } from '../utils';

const multiLineInputStyles = {
  '& .MuiInputBase-root': {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    border: 0,
    overflow: 'hidden',
  },
  '& .MuiTextField-root': {
    textAlign: 'left',
  },
  '& .MuiInputBase-inputMultiline': {
    border: '0 !important',
  },
};

export interface AdditionalInformationFieldProps {
  value?: string;
  onChange: (value: string) => void;
  required?: boolean;
  fieldProps?: Partial<TextFieldProps<'any-text'>>;
  validatorProps?: Parameters<typeof useMultilineTextValidator>[0];
  gridItemProps?: Partial<FormGridItemProps>;
}

export const AdditionalInformationField: React.FC<
  AdditionalInformationFieldProps
> = ({
  value,
  onChange,
  required = false,
  fieldProps,
  validatorProps,
  gridItemProps,
}) => {
  const label = 'Additional information or comments';
  const validator = useMultilineTextValidator({
    label,
    required,
    ...validatorProps,
  });

  return (
    <FormGridItem
      size={12}
      {...gridItemProps}
      sx={getRequiredFieldSx(required)}
    >
      <TextField
        name={'additionalInformation'}
        data-testid='additionalInformation'
        onChange={(e) => onChange(e.target.value)}
        value={value}
        multiline
        fullWidth
        label={label}
        {...defaultInputProps}
        placeholder={''}
        validator={validator}
        sx={multiLineInputStyles}
        {...fieldProps}
      />
    </FormGridItem>
  );
};
